// // src/pages/Dashboard/Earnings.js
// import React, { useState, useEffect } from "react"
// import { Row, Col, Card, CardBody, ButtonGroup, Button } from "reactstrap"
// import ReactApexChart from "react-apexcharts"
// import getChartColorsArray from "../../components/Common/ChartsDynamicColor"
// import { getTotals } from "../../helpers/api_helper"

// const Earnings = ({
//   dataColors = '["--bs-primary", "--bs-success", "--bs-info", "--bs-warning", "--bs-danger"]',
//   filters = {},
// }) => {
//   const chartColors = getChartColorsArray(dataColors)

//   const categories = [
//     { id: "withdraw", label: "Total Withdraw" },
//     { id: "added", label: "Total Added" },
//     { id: "debit", label: "Total Debit" },
//     { id: "credit", label: "Total Credit" },
//   ]

//   const [selectedCategory, setSelectedCategory] = useState("withdraw")
//   const [selectedPeriod, setSelectedPeriod] = useState("overall")
//   const [currentData, setCurrentData] = useState({
//     monthly: Array(12).fill(0), // graph ke liye mock (sirf line draw karne ke liye)
//     thisMonth: 0, // real API se
//     lastMonth: 0, // real API se nahi to 0
//     breakdown: [], // real API se
//   })
//   const [loading, setLoading] = useState(true)
//   const [errorMsg, setErrorMsg] = useState(null)

//   useEffect(() => {
//     const loadEarningsData = async () => {
//       setLoading(true)
//       setErrorMsg(null)

//       try {
//         const res = await getTotals(filters)

//         if (res.success) {
//           const breakdown = res.breakdown || {}
//           const totals = res.totals || {}

//           const safeNumber = val => parseFloat(val) || 0

//           let thisMonthValue = 0
//           let realBreakdown = []

//           if (selectedCategory === "withdraw") {
//             thisMonthValue = safeNumber(breakdown.withdraw)
//           } else if (selectedCategory === "added") {
//             thisMonthValue = safeNumber(breakdown.added_money)
//           } else if (selectedCategory === "debit") {
//             thisMonthValue = safeNumber(totals.total_debit)
//             realBreakdown = [
//               {
//                 name: "Bajaj 599",
//                 value: safeNumber(breakdown.bajaj_599_debit),
//               },
//               {
//                 name: "Bajaj 699",
//                 value: safeNumber(breakdown.bajaj_699_debit),
//               },
//               {
//                 name: "Bajaj Other",
//                 value: safeNumber(breakdown.bajaj_other_debit),
//               },
//               { name: "Other Debit", value: safeNumber(breakdown.other_debit) },
//             ]
//           } else if (selectedCategory === "credit") {
//             thisMonthValue = safeNumber(totals.total_credit)
//             realBreakdown = [
//               {
//                 name: "Bajaj Normal Credit",
//                 value: safeNumber(breakdown.bajaj_normal_credit),
//               },
//               {
//                 name: "Other Credit",
//                 value: safeNumber(breakdown.other_credit),
//               },
//               {
//                 name: "Bajaj Refund",
//                 value: safeNumber(breakdown.bajaj_refund),
//               },
//               {
//                 name: "Other Refund",
//                 value: safeNumber(breakdown.other_refund),
//               },
//             ]
//           }

//           // Mock monthly data ONLY for graph line (visual purpose, not used in stats)
//           const monthlyMock = {
//             withdraw: [
//               45000, 52000, 48000, 61000, 55000, 72000, 68000, 59000, 75000,
//               82000, 78000, 92000,
//             ],
//             added: [
//               120000, 135000, 148000, 165000, 180000, 195000, 210000, 225000,
//               240000, 255000, 270000, 285000,
//             ],
//             debit: [
//               30000, 35000, 40000, 38000, 42000, 45000, 48000, 50000, 52000,
//               55000, 58000, 62000,
//             ],
//             credit: [
//               150000, 165000, 180000, 195000, 210000, 225000, 240000, 255000,
//               270000, 285000, 300000, 315000,
//             ],
//           }

//           setCurrentData({
//             monthly: monthlyMock[selectedCategory] || Array(12).fill(0), // only for line chart
//             thisMonth: thisMonthValue, // real API se
//             lastMonth: 0, // abhi backend se nahi aa raha
//             breakdown: realBreakdown, // real API se
//           })
//         } else {
//           setErrorMsg(res.error || "Failed to load earnings data")
//         }
//       } catch (err) {
//         console.error("Earnings fetch error:", err)
//         setErrorMsg("Failed to load earnings data")
//       } finally {
//         setLoading(false)
//       }
//     }

//     loadEarningsData()
//   }, [filters, selectedCategory]) // filters ya category change pe refetch

//   const options = {
//     chart: {
//       toolbar: { show: false },
//       dropShadow: {
//         enabled: true,
//         color: "#000",
//         top: 18,
//         left: 7,
//         blur: 8,
//         opacity: 0.2,
//       },
//     },
//     dataLabels: { enabled: false },
//     colors: chartColors,
//     stroke: {
//       curve: "smooth",
//       width: 3,
//     },
//     xaxis: {
//       categories: [
//         "Jan",
//         "Feb",
//         "Mar",
//         "Apr",
//         "May",
//         "Jun",
//         "Jul",
//         "Aug",
//         "Sep",
//         "Oct",
//         "Nov",
//         "Dec",
//       ],
//     },
//     tooltip: {
//       y: {
//         formatter: val => "₹" + val.toLocaleString("en-IN"),
//       },
//     },
//   }

//   const series = [
//     {
//       name: categories.find(c => c.id === selectedCategory)?.label || "Value",
//       data: currentData.monthly, // mock only for visual line
//     },
//   ]

//   // Percentage only for Debit & Credit
//   const showChangePercent = ["debit", "credit"].includes(selectedCategory)
//   const changePercent =
//     showChangePercent && currentData.lastMonth !== 0
//       ? (
//           ((currentData.thisMonth - currentData.lastMonth) /
//             currentData.lastMonth) *
//           100
//         ).toFixed(1)
//       : "0.0"

//   const isPositive = Number(changePercent) >= 0

//   return (
//     <Card className="shadow border-0 h-100">
//       <CardBody className="p-4">
//         {/* Top Controls */}
//         <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
//           <h4 className="card-title mb-0 fw-semibold">
//             {categories.find(c => c.id === selectedCategory)?.label ||
//               "Earnings"}
//           </h4>

//           <div className="d-flex flex-wrap gap-3">
//             <ButtonGroup size="sm">
//               {categories.map(cat => (
//                 <Button
//                   key={cat.id}
//                   color={selectedCategory === cat.id ? "primary" : "light"}
//                   className="px-3"
//                   onClick={() => setSelectedCategory(cat.id)}
//                 >
//                   {cat.label}
//                 </Button>
//               ))}
//             </ButtonGroup>

//             <div
//               className="input-group input-group-sm"
//               style={{ width: "auto" }}
//             >
//               <select
//                 className="form-select form-select-sm"
//                 value={selectedPeriod}
//                 onChange={e => setSelectedPeriod(e.target.value)}
//                 disabled
//               >
//                 <option value="overall">Overall</option>
//               </select>
//               <span className="input-group-text">Period</span>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className="text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </div>
//         ) : errorMsg ? (
//           <div className="text-center py-5 text-danger">
//             <h5>{errorMsg}</h5>
//           </div>
//         ) : (
//           <Row className="align-items-start">
//             {/* Left Side – Stats + Breakdown */}
//             <Col lg="4" className="mb-4 mb-lg-0">
//               <div className="text-muted">
//                 {/* Main Value */}
//                 <div className="mb-4 pb-3 border-bottom">
//                   <p className="mb-1 fw-medium text-dark">
//                     {categories.find(c => c.id === selectedCategory)?.label}
//                   </p>
//                   <h4 className="mb-2 fw-bold text-dark">
//                     ₹{currentData.thisMonth.toLocaleString("en-IN")}
//                   </h4>

//                   {/* Percentage only for Debit & Credit */}
//                   {showChangePercent && (
//                     <div className="d-flex align-items-center flex-wrap">
//                       <span
//                         className={`badge bg-soft-${
//                           isPositive ? "success" : "danger"
//                         } font-size-13 me-2 px-2 py-1`}
//                       >
//                         {isPositive ? "+" : ""}
//                         {changePercent}%
//                       </span>
//                       <span className="fs-13">from previous month</span>
//                     </div>
//                   )}
//                 </div>

//                 {/* Last Month - only for Debit & Credit */}
//                 {showChangePercent && (
//                   <div className="mb-4 pb-3 border-bottom">
//                     <p className="mb-1 fw-medium">Last Month</p>
//                     <h5 className="mb-2 fw-bold">
//                       ₹{currentData.lastMonth.toLocaleString("en-IN")}
//                     </h5>
//                   </div>
//                 )}

//                 {/* Breakdown - only for Debit & Credit */}
//                 {currentData.breakdown.length > 0 && (
//                   <div>
//                     <p className="mb-2 fw-medium">Breakdown</p>
//                     <ul className="list-unstyled mb-0">
//                       {currentData.breakdown.map((item, idx) => (
//                         <li
//                           key={idx}
//                           className="d-flex justify-content-between mb-2"
//                         >
//                           <span className="text-muted">{item.name}</span>
//                           <span className="fw-medium">
//                             ₹{item.value.toLocaleString("en-IN")}
//                           </span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}

//                 <div className="mt-4">
//                   <a href="#" className="btn btn-primary btn-sm">
//                     View Full Report{" "}
//                     <i className="mdi mdi-chevron-right ms-1"></i>
//                   </a>
//                 </div>
//               </div>
//             </Col>

//             {/* Chart – mock monthly data only for line visualization */}
//             <Col lg="8">
//               <div id="line-chart" dir="ltr">
//                 <ReactApexChart
//                   series={series}
//                   options={options}
//                   type="line"
//                   height={320}
//                   className="apex-charts"
//                 />
//               </div>
//             </Col>
//           </Row>
//         )}
//       </CardBody>
//     </Card>
//   )
// }

// export default Earnings

// src/pages/Dashboard/Earnings.js
import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, ButtonGroup, Button } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor"
import { getTotals } from "../../helpers/api_helper"

const Earnings = ({
  dataColors = '["--bs-primary", "--bs-success", "--bs-info", "--bs-warning", "--bs-danger"]',
  filters = {},
}) => {
  const chartColors = getChartColorsArray(dataColors)

  const categories = [
    { id: "withdraw", label: "Total Withdraw" },
    { id: "added", label: "Total Added" },
    { id: "debit", label: "Total Debit" },
    { id: "credit", label: "Total Credit" },
  ]

  const [selectedCategory, setSelectedCategory] = useState("withdraw")
  const [currentData, setCurrentData] = useState({
    monthly: Array(12).fill(0), // graph ke liye mock (sirf line draw karne ke liye)
    thisMonth: 0, // real API se
    lastMonth: 0, // abhi use nahi ho raha
    breakdown: [], // real API se
  })
  const [loading, setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState(null)

  useEffect(() => {
    const loadEarningsData = async () => {
      setLoading(true)
      setErrorMsg(null)

      try {
        const res = await getTotals(filters)

        if (res.success) {
          const breakdown = res.breakdown || {}
          const totals = res.totals || {}

          const safeNumber = val => parseFloat(val) || 0

          let thisMonthValue = 0
          let realBreakdown = []

          if (selectedCategory === "withdraw") {
            thisMonthValue = safeNumber(breakdown.withdraw)
          } else if (selectedCategory === "added") {
            thisMonthValue = safeNumber(breakdown.added_money)
          } else if (selectedCategory === "debit") {
            thisMonthValue = safeNumber(totals.total_debit)
            realBreakdown = [
              {
                name: "Bajaj 599",
                value: safeNumber(breakdown.bajaj_599_debit),
              },
              {
                name: "Bajaj 699",
                value: safeNumber(breakdown.bajaj_699_debit),
              },
              {
                name: "Bajaj Other",
                value: safeNumber(breakdown.bajaj_other_debit),
              },
              { name: "Other Debit", value: safeNumber(breakdown.other_debit) },
            ]
          } else if (selectedCategory === "credit") {
            thisMonthValue = safeNumber(totals.total_credit)
            realBreakdown = [
              {
                name: "Bajaj Normal Credit",
                value: safeNumber(breakdown.bajaj_normal_credit),
              },
              {
                name: "Other Credit",
                value: safeNumber(breakdown.other_credit),
              },
              {
                name: "Bajaj Refund",
                value: safeNumber(breakdown.bajaj_refund),
              },
              {
                name: "Other Refund",
                value: safeNumber(breakdown.other_refund),
              },
            ]
          }

          // Mock monthly data ONLY for graph line (visual purpose)
          const monthlyMock = {
            withdraw: [
              45000, 52000, 48000, 61000, 55000, 72000, 68000, 59000, 75000,
              82000, 78000, 92000,
            ],
            added: [
              120000, 135000, 148000, 165000, 180000, 195000, 210000, 225000,
              240000, 255000, 270000, 285000,
            ],
            debit: [
              30000, 35000, 40000, 38000, 42000, 45000, 48000, 50000, 52000,
              55000, 58000, 62000,
            ],
            credit: [
              150000, 165000, 180000, 195000, 210000, 225000, 240000, 255000,
              270000, 285000, 300000, 315000,
            ],
          }

          setCurrentData({
            monthly: monthlyMock[selectedCategory] || Array(12).fill(0),
            thisMonth: thisMonthValue,
            lastMonth: 0,
            breakdown: realBreakdown,
          })
        } else {
          setErrorMsg(res.error || "Failed to load earnings data")
        }
      } catch (err) {
        console.error("Earnings fetch error:", err)
        setErrorMsg("Failed to load earnings data")
      } finally {
        setLoading(false)
      }
    }

    loadEarningsData()
  }, [filters, selectedCategory])

  const options = {
    chart: {
      toolbar: { show: false },
      dropShadow: {
        enabled: true,
        color: "#000",
        top: 18,
        left: 7,
        blur: 8,
        opacity: 0.2,
      },
    },
    dataLabels: { enabled: false },
    colors: chartColors,
    stroke: {
      curve: "smooth",
      width: 3,
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    tooltip: {
      y: {
        formatter: val => "₹" + val.toLocaleString("en-IN"),
      },
    },
  }

  const series = [
    {
      name: categories.find(c => c.id === selectedCategory)?.label || "Value",
      data: currentData.monthly,
    },
  ]

  return (
    <Card className="shadow border-0 h-100">
      <CardBody className="p-4">
        {/* Top Controls – sirf tabs rakhe hain, period hata diya */}
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
          <h4 className="card-title mb-0 fw-semibold">
            {categories.find(c => c.id === selectedCategory)?.label ||
              "Earnings"}
          </h4>

          <ButtonGroup size="sm">
            {categories.map(cat => (
              <Button
                key={cat.id}
                color={selectedCategory === cat.id ? "primary" : "light"}
                className="px-3"
                onClick={() => setSelectedCategory(cat.id)}
              >
                {cat.label}
              </Button>
            ))}
          </ButtonGroup>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : errorMsg ? (
          <div className="text-center py-5 text-danger">
            <h5>{errorMsg}</h5>
          </div>
        ) : (
          <Row className="align-items-start">
            {/* Left Side – Stats + Breakdown */}
            <Col lg="4" className="mb-4 mb-lg-0">
              <div className="text-muted">
                {/* Main Value */}
                <div className="mb-4 pb-3 border-bottom">
                  <p className="mb-1 fw-medium text-dark">
                    {categories.find(c => c.id === selectedCategory)?.label}
                  </p>
                  <h4 className="mb-2 fw-bold text-dark">
                    ₹{currentData.thisMonth.toLocaleString("en-IN")}
                  </h4>
                  {/* Percentage aur "from previous month" hata diya gaya */}
                </div>

                {/* Last Month section bhi hata diya gaya */}

                {/* Breakdown - sirf debit & credit ke liye */}
                {currentData.breakdown.length > 0 && (
                  <div>
                    <p className="mb-2 fw-medium">Breakdown</p>
                    <ul className="list-unstyled mb-0">
                      {currentData.breakdown.map((item, idx) => (
                        <li
                          key={idx}
                          className="d-flex justify-content-between mb-2"
                        >
                          <span className="text-muted">{item.name}</span>
                          <span className="fw-medium">
                            ₹{item.value.toLocaleString("en-IN")}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </Col>

            {/* Chart */}
            <Col lg="8">
              <div id="line-chart" dir="ltr">
                <ReactApexChart
                  series={series}
                  options={options}
                  type="line"
                  height={320}
                  className="apex-charts"
                />
              </div>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  )
}

export default Earnings
